import React, { useState, useCallback } from "react";
import { Tabs } from "antd";
import { FileTextOutlined, PlayCircleOutlined } from "@ant-design/icons";
import ReadingsTab from "./ReadingsTab";
import RecordingsTab from "./RecordingsTab";
import { useSearchParams } from "react-router";

export default function ContentLibraryContent(): React.ReactNode | null {
  const [activeKey, setActiveKey] = useState("1");
  const [, setSearchParams] = useSearchParams();

  const handleTabChange = useCallback((key: string) => {
    setActiveKey(key);
    setSearchParams({}, { replace: true });
  }, []);

  const items = [
    {
      key: "1",
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FileTextOutlined />
          Readings
        </span>
      ),
      children: activeKey === "1" ? <ReadingsTab /> : null,
    },
    {
      key: "2",
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <PlayCircleOutlined />
          Recordings
        </span>
      ),
      children: activeKey === "2" ? <RecordingsTab /> : null,
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Tabs activeKey={activeKey} onChange={handleTabChange} items={items} />
    </div>
  );
}
